import { array, mixed, object, string } from "yup";

import { Message } from "./Message";
import { InstanceType } from "./types";
import { IUser } from "../../types/auth/IUser";

export const folderSchema = object({
  instance: object({
    id: string().required(Message.instanceIdRequired),
    type: mixed<InstanceType>().oneOf([InstanceType.FOLDER], Message.instanceTypeFolder),
    path: array<string>().min(1, Message.instancePathLength),
  }).required(Message.instanceRequired),
  user: object<IUser>().required(Message.userRequired),
});

export const instanceSchema = object({
  instance: object({
    id: string().required(Message.instanceIdRequired),
    type: mixed<InstanceType>().required(Message.instanceType),
    path: array<string>().min(1, Message.instancePathLength),
  }).required(Message.instanceRequired),
  user: object<IUser>().required(Message.userRequired),
});
